<div class="tw-flex tw-flex-wrap tw-gap-6 tw-mb-2">
  <div *ngFor="let folder of folders; trackBy: trackById">
    <p-card
      styleClass="tw-h-full tw-w-72 tw-cursor-pointer hover:tw-bg-gray-50"
      class="folder"
      (click)="selectFolder(folder.id)"
    >
      <div class="tw-flex tw-items-center tw-justify-between">
        <div class="tw-flex tw-items-center tw-gap-4">
          <i
            class="fa-solid tw-text-2xl tw-text-gray-500"
            [ngClass]="folder.read_only ? 'fa-folder-user' : 'fa-folder'"
          ></i>
          <div>
            <div class="tw-font-medium tw-truncate tw-max-w-44">
              {{ folder.name }}
            </div>
            <div
              *ngIf="folder.read_only && folder.owner"
              class="tw-text-xs tw-text-gray-500 tw-truncate tw-max-w-44 tw-flex tw-items-center tw-gap-1"
            >
              <span>Shared by {{ folder.owner }}</span>
            </div>
          </div>
        </div>
        <ng-container *ngIf="!folder.read_only; else menuButtonSpacer">
          <p-button
            icon="fa-solid fa-ellipsis-vertical"
            [rounded]="true"
            [text]="true"
            severity="secondary"
            size="large"
            (onClick)="openMenu($event, folder)"
          ></p-button>
        </ng-container>
        <ng-template #menuButtonSpacer>
          <span
            class="tw-inline-block tw-w-10 tw-h-10"
            aria-hidden="true"
          ></span>
        </ng-template>
      </div>
    </p-card>
  </div>
</div>

<p-menu
  #menu
  [model]="menuItems"
  [popup]="true"
  appendTo="body"
></p-menu>

<dialog-template
  dialogId="removeFolder"
  [header]="'Remove &quot;' + activeFolder?.name + '&quot; folder?'"
  primaryBtnText="Remove"
  secondaryBtnText="Keep"
  primaryBtnSeverity="danger"
  (primaryBtnClicked)="confirmRemove()"
>
  <ng-template #contentTemplate>
    <div class="tw-mb-6">
      Removing this folder won't delete its reports. They will still appear in the reports list. Continue?
    </div>
  </ng-template>
</dialog-template>
